// extracted by mini-css-extract-plugin
module.exports = {"containerForm":"Style_containerForm__3jwCE","conteninerText":"Style_conteninerText__n6t9C","message":"Style_message__2TkSZ","containerMessage":"Style_containerMessage__30waw"};